import React, {Component} from 'react';

export default class Save extends Component {
    render(){
        const macBookImg = require('images/brand_ambassadors/save_gold_macbook.png');

        return(
            <div className='gr-12 save'>
                <div className='row'>
                    <div className='gr-7'>
                        <img src={macBookImg} className='save-macbook-image' />
                    </div>
                    <div className='gr-5 save-text'>
                        <div className='gr-12 save-text-header'>
                            <h1>Engagement and cost efficiency</h1>
                        </div>
                        <div className='gr-4 save-text-influencers'>
                            <span>400+</span>
                            <p>brand ambassadors</p>
                        </div>
                        <div className='gr-4 save-text-rate'>
                            <span>1M</span>
                            <p>engagements</p>
                        </div>
                        <div className='gr-4 save-text-reached'>
                            <span>$0.13</span>
                            <p>cost per engagement</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/save.js